<template>
  <div class="vx-card" id="individual">
    <div class="vx-card__body card-body">
      <form v-if="!loading">
        <div class="vx-row mb-2">
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-model="legalInfo.companyName"
              name="name"
              :label="$t('CompanyName')"
              readonly="readonly"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('name')">{{
              errors.first("name")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-model="legalInfo.companyRegistrationNumber"
              name="regNo"
              :label="$t('CompanyRegistrationNumber')"
              readonly="readonly"
              v-validate="{ regex: '^([0-9]+)$', required: 'true' }"
            />
            <span class="text-danger text-sm" v-show="errors.has('regNo')">{{
              errors.first("regNo")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-model="legalInfo.companyNationalId"
              name="nationalId"
              :label="$t('CompanyNationalId')"
              readonly="readonly"
              v-validate="{ regex: '^([0-9]+)$', required: 'true' }"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('nationalId')"
              >{{ errors.first("nationalId") }}</span
            >
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-model="legalInfo.economicCode"
              name="ecoCode"
              :label="$t('EconomicCode')"
              readonly="readonly"
              v-validate="{ regex: '^([0-9]+)$', required: 'true' }"
            />
            <span class="text-danger text-sm" v-show="errors.has('ecoCode')">{{
              errors.first("ecoCode")
            }}</span>
          </div>
        </div>
        <div class="vx-row  mb-2">
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-model="legalInfo.email"
              name="email"
              v-validate="'email'"
              readonly="readonly"
              :label="$t('Email')"
            />
            <span class="text-danger text-sm" v-show="errors.has('email')">{{
              errors.first("email")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-for="phone in legalInfo.customerPhonesQuery"
              :key="phone.id"
              v-model="phone.area"
              name="area"
              v-validate="{ regex: '^([0-9]+)$' }"
              readonly="readonly"
              :label="$t('PhoneArea')"
            />
            <span class="text-danger text-sm" v-show="errors.has('area')">{{
              errors.first("area")
            }}</span>
          </div>
          <div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <vs-input
              class="inputx mb-2 mt-1"
              v-for="phone in legalInfo.customerPhonesQuery"
              :key="phone.id"
              v-model="phone.number"
              name="number"
              v-validate="{ regex: '^([0-9]+)$' }"
              readonly="readonly"
              :label="$t('PhoneNumber')"
            />
            <span class="text-danger text-sm" v-show="errors.has('number')">{{
              errors.first("number")
            }}</span>
          </div>
          <!--<div class="vx-col lg:w-1/4 sm:w-1/3 w-full">
            <vs-input class="inputx mb-2 mt-1"
                      v-for="address in legalInfo.customerAddressesInfoQuery"
                      v-model="address.postalCode"
                      name="postalCode"
                      v-validate="{regex: '^([0-9]+)$',digits:'10'}"
                      :label="$t('PostalCode')" />
            <span class="text-danger text-sm" v-show="errors.has('postalCode')">{{ errors.first('postalCode') }}</span>

          </div>-->
        </div>
        <!--<div class="vx-row mb-2">
          <div class="vx-col  w-full">
            <vs-input class="inputx mb-2 mt-1"
                      v-for="address in legalInfo.customerAddressesInfoQuery"
                      v-model="address.address"
                      name="address"
                      :label="$t('Address')" />
          </div>
        </div>-->
        <!--<div class="vx-row">
          <div class="vx-col  w-full">
            <vs-button type="filled" class="float-right submit-btn" @click.prevent="submitForm()" :disabled="disabled">{{$t('Save')}}</vs-button>
          </div>
        </div>-->
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Validator } from "vee-validate";
const dict = {
  custom: {
    name: {
      required: "لطفا نام شرکت را وارد نمایید."
    },

    regNo: {
      required: "لطفا شماره ثبت را وارد نمایید.",
      regex: "شماره ثبت نامعتبر می باشد"
    },
    nationalId: {
      required: "لطفا شناسه ملی را وارد نمایید.",
      regex: "شناسه ملی  نامعتبر می باشد"
    },
    ecoCode: {
      required: "لطفا کد اقتصادی را وارد نمایید.",
      regex: " کد اقتصادی  نامعتبر می باشد"
    },
    email: {
      email: "پست الکترونیک نامعتبر می باشد."
    },
    area: {
      regex: "پیش شماره نامعتبر می باشد."
    },
    number: {
      regex: "شماره تلفن نامعتبر می باشد."
    },
    postalCode: {
      regex: "کدپستی نامعتبر می باشد.",
      digits: "کدپستی نامعتبر می باشد."
    }
  }
};
Validator.localize("fa", dict);
export default {
  data() {
    return {
      legalInfo: {},
      disabled: false
    };
  },
  mounted() {
    this.load();
  },
  computed: {
    ...mapGetters({
      legal: "legal/details",
      loading: "legal/loading"
    })
  },
  methods: {
    ...mapActions({
      fetchSingleLegal: "legal/fetchSingle",
      updateLegal: "legal/update"
    }),
    load() {
      var id = this.$route.params.id;
      this.fetchSingleLegal(id).then(() => {
        this.legalInfo = Object.assign({}, this.legal);
      });
    },
    submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.disabled = true;
          this.legalInfo.customerId = this.legalInfo.id;
          this.legalInfo.customerProvinceInfoCommand = this.legalInfo.customerProvinceQuery;
          this.legalInfo.customerAddressesInfoCommand = this.legalInfo.customerAddressesInfoQuery;
          this.legalInfo.customerPhonesCommand = this.legalInfo.customerPhonesQuery;
          this.legalInfo.emailAddress = this.legalInfo.email;
          this.legalInfo.customerOwner = this.legalInfo.owner;
          this.updateLegal(this.legalInfo).then(() => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
              showConfirmButton: false,
              timer: 2000
            }).then(() => {
              this.$router.push("/Customers/Index");
            });
            this.$validator.reset();
          });
        } else {
          // form have errors
        }
      });
    }
  }
};
</script>
